import React, {useEffect, useState, useLayoutEffect} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import {ItemProductGift} from "../../../components/mobile/product";
import {getListcampaign} from "../../../service/campaignService";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import { useLocation } from "@reach/router";

import './css/index.css';
const Productgift=()=> {
    const location = useLocation();
    const uri={
        url :'https://bibomart.com.vn/',
        package : 'vn.com.bibomart.bibomart',
        app_name : 'Bibo Mart',
        app_store_id : '1464298193'
    }
    const [meta, setMeta] = useState();
    const [itemData, setItemData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const fetchDataProductGift = (start) => {
        try{
            getListcampaign(start,20).then((response) => {
                if(response.status === 200 && response.message.length >0 && response.message !== "Không tìm thấy dữ liệu."){
                    setItemData((prevData) => [...prevData, ...response.message]);
                    setTotalItem(response.metadata?.total_item);
                }
            }); 
        }catch(e){
            console.log(e);
        }
    };
    
    useEffect(()=>{
        setLoadMoreStart(0);
        fetchDataProductGift(0); 
    },[]);
    const handleClickOnTop=()=>{
        window.scrollTo(0,0);
    }

    const handleLoadMore = (e) => {
        setLoadMoreStart(0);
        const newStart = loadMoreStart + 1;
        setLoadMoreStart(newStart);
        fetchDataProductGift(newStart);

      };

const [scrollPosition, setPosition] = useState(0);
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);

const InfiniteScroll = ({ loadMore }) => {
    useEffect(() => {
      const handleScroll = () => {
        var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1) {
            loadMore();
         }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, [loadMore]);
  
    return null;
};
  return (
   <Layout>
              {/* <h1 className='d-none'>Hàng hot deal</h1> */}
    <div className="bg-page" id="hot-deal">
    <HeaderMobile Type={'Header2'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {"MUA HÀNG TẶNG QUÀ"} /> 

    
    {
            itemData.length > 0 ? (
                <div className="row mgt-10 bg-detail" id="san-qua">
                    <div className="col-12">
                        
                        <div className="row mgt-10 pdx-5">
                            <ul className="row col-ul-1">
                                {
                                    itemData.length > 0 ? (
                                        itemData.map((item, i)=>{
                                            return <ItemProductGift key={i} item={item} index={i}/>
                                        })
                                    ):
                                    (
                                    <li>
                                        <div>Không có sản phẩm</div>
                                    </li>
                                    )    
                                }
                            </ul>
                        </div>
                    </div>
                    </div>   
            ):(null)
        }
         <InfiniteScroll loadMore={handleLoadMore} />
    </div>
    <div className="row">
        <div className="col-12 go-to-top" onClick={handleClickOnTop}>
            <img src="/../images/product/go_to_top.png" alt="icon"/>
        </div>
    </div>
   </Layout>
  )
}
export default Productgift;